export default {
  getSurvey: state => state.survey
}
